import {Modals} from "./Modals";
import Utilities from "./Utilities";
import {Alerts} from "./Alerts";

export default class JSTree {

    static categoryTree (selector)
    {
        if(!$(selector).find('[data-categoryTree]').length)
            return false;

        if($.fn.selectize === undefined)
            require('jstree');

        $(selector).find('[data-categoryTree]').each(function () {
            const $this = $(this)
            $(this).jstree({
                core: {
                    data: {
                        url: '/products/categories/tree',
                    },
                    "check_callback": true,
                    themes: {
                        icons: false
                    }
                },
                contextmenu:{
                    "items": function($node) {
                        const tree = $this.jstree(true);
                        return {
                            "Create": {
                                "separator_before": false,
                                "separator_after": false,
                                "label": "Create",
                                "action": function (obj) {

                                    Modals.show('/products/categories/create', 'addCategoryCard', false, function ($modal){
                                        $("#categoryParent", $modal).data('selected', $node.id)
                                        $("#categoryParent", $modal)[0].selectize.getItem($node.id)
                                    });

                                }
                            },
                            "Edit": {
                                "separator_before": false,
                                "separator_after": false,
                                "label": "Edit",
                                "action": function (obj) {
                                    Modals.show('/products/categories/' + $node.id + '/edit', 'editCategoryCard', false, function ($modal){
                                        $("form", $modal).attr('data-on-success', 'categoryTreeEdit')
                                    });
                                }
                            },
                            "Remove": {
                                "separator_before": false,
                                "separator_after": false,
                                "label": "Remove",
                                "action": function (obj) {
                                    Utilities.confirmDialog('Are you sure you want to delete this category?', 'delete', function () {
                                        axios.delete('/products/categories/' + $node.id).then(response => {

                                            if(response.data.session.hasOwnProperty('success'))
                                                Alerts.success(response['data']['session']['success']);

                                            tree.delete_node($node);
                                        });
                                    })
                                }
                            }
                        };
                    }
                },
                plugins: ["contextmenu" ]
            });
        })
    }
}
